/**
 * mdzo-cart-writer.js v4 (2026-09-19) — gemeinsamer, serialisierter Schreiber fuer Cart-Attribute und Rabattcode,
 * seit v2 auch gemeinsamer LESER fuer /cart.js.
 *
 * NEU v4 (2026-09-19): window.mdzoCartNachliefern(fn) — kurz vor dem Abschicken fragt der Schreiber
 * registrierte Nachlieferer nach ausstehenden Attributen und nimmt sie mit. Damit faehrt ein
 * aufschiebbarer Write (Marge) auf einem fremden Write mit, statt danach nochmal einzeln zu laufen.
 *
 * NEU v3 (2026-09-19): Die Antwort eines Cart-Writes fuellt den Lese-Merker, statt ihn nur zu verwerfen.
 * update.js/change.js/clear.js liefern den vollstaendigen Korb; der Read direkt nach einem Write entfaellt
 * damit. Gilt auch fuer FREMDE Writes (z. B. rcc-visitor-id der RCC-App auf der Landeseite), weil der
 * Schreiber window.fetch umhuellt. add.js ist ausgenommen (liefert nur die Zeile).
 *
 * NEU v2 (2026-09-18): GET /cart.js wird zusammengelegt. Gemessen: je Seitenaufruf lasen vier Skripte den Korb
 * (mb-mindestbestellwert, custom.js, md-google-price, md-vk-bereinigen), drei davon binnen ~300 ms, jeder Read
 * 0,9-3,7 s. Ein laufender Read wird geteilt, das Ergebnis LESE_TTL_MS lang wiederverwendet — aber nur, solange
 * kein Cart-Write dazwischenlag (Generation steigt bei Start UND Ende jedes Writes, eigener wie fremder). Die
 * lesenden Skripte bleiben unveraendert; jeder Aufrufer bekommt eine eigene Response. Zaehler fuer Messungen:
 * window.mdzoCartLesen = { netz, geteilt, merker }.
 *
 * Anlass (gemessen 14.09.): custom.js (refcons/ref*) und md-google-price.js (_kx/_kxg, GAD-discount) schickten nach jedem
 * Add je einen eigenen POST /cart/update.js, gleichzeitig und parallel zu Theme-Writes. Ein Attribut-Write, der waehrend
 * eines change.js unterwegs war, hat eine gerade entfernte Zeile wiederhergestellt. Shopify akzeptiert attributes und
 * discount in EINEM Body (gemessen: 200, ungueltiger Code blockiert die Attribute nicht, applicable:false).
 *
 * window.mdzoCartWrite({ attributes?: {k: v}, discount?: 'CODE1,CODE2' | '' }) -> Promise<cart | null>
 *  - sammelt Aufrufe SAMMEL_MS lang und verschmilzt sie zu einem Body (Attribute schluesselweise, discount letzter Wert;
 *    discount wird NUR gesendet, wenn ein Aufrufer ihn gesetzt hat — '' loescht alle Codes),
 *  - schickt immer nur EINEN Write auf einmal; wartet vorher, bis kein fremder Cart-Write (add/change/update/clear des
 *    Themes oder anderer Skripte) mehr unterwegs ist (hoechstens MAX_WARTEN_MS),
 *  - wiederholt einen fehlgeschlagenen Write einmal; Aufrufer bekommen das Cart-JSON oder null.
 * Eigene Writes tragen den Header X-Mdzo-Writer und zaehlen im eigenen Beobachter nicht als fremd; andere Beobachter
 * (md-vk-bereinigen.js) sehen sie ueber window.fetch weiterhin. Skripte ohne diesen Schreiber (Fallback) schreiben direkt.
 */
(function () {
  'use strict';
  if (typeof window.mdzoCartWrite === 'function') return;
  var UPDATE = '/cart/update.js', SAMMEL_MS = 300, TAKT_MS = 100, MAX_WARTEN_MS = 5000, WIEDERHOLUNG_MS = 800;
  var MARKER = 'X-Mdzo-Writer';
  var LESE_TTL_MS = 2500;   // kurz: Aenderungen von aussen (zweiter Tab) bleiben hoechstens so lange unsichtbar
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal !== 'function') return;

  // ---- v2: Reads auf /cart.js zusammenlegen ----
  var schreibGen = 0;        // steigt bei Start und Ende JEDES Cart-Writes; aeltere Reads sind danach wertlos
  var leseLauf = null;       // { gen, p: Promise<{status, statusText, ct, text}> }
  var leseMerker = null;     // { gen, at, status, statusText, ct, text }
  var zaehler = window.mdzoCartLesen = { netz: 0, geteilt: 0, merker: 0 };
  function antwortAus(d) {
    return new Response(d.text, { status: d.status, statusText: d.statusText, headers: { 'Content-Type': d.ct || 'application/json; charset=utf-8' } });
  }
  function istCartRead(url) {
    try { var u = new URL(url, window.location.href); return u.origin === window.location.origin && /(^|\/)cart\.js$/.test(u.pathname); }
    catch (e) { return false; }
  }
  function cartLesen(selbst, args) {
    var jetzt = Date.now();
    if (leseMerker && leseMerker.gen === schreibGen && jetzt - leseMerker.at < LESE_TTL_MS) { zaehler.merker++; return Promise.resolve(antwortAus(leseMerker)); }
    if (leseLauf && leseLauf.gen === schreibGen) { zaehler.geteilt++; return leseLauf.p.then(antwortAus); }
    zaehler.netz++;
    var lauf = { gen: schreibGen, p: null };
    lauf.p = fetchOriginal.apply(selbst, args).then(function (r) {
      return r.text().then(function (text) { return { status: r.status, statusText: r.statusText, ct: r.headers.get('content-type'), text: text }; });
    }).then(function (d) {
      if (leseLauf === lauf) leseLauf = null;
      if (lauf.gen === schreibGen && d.status === 200) leseMerker = { gen: lauf.gen, at: Date.now(), status: d.status, statusText: d.statusText, ct: d.ct, text: d.text };
      return d;
    }, function (err) { if (leseLauf === lauf) leseLauf = null; throw err; });
    leseLauf = lauf;
    return lauf.p.then(antwortAus);
  }
  function schreibStart() { schreibGen++; leseMerker = null; }
  function schreibEnde() { schreibGen++; leseMerker = null; }

  // v3: Merker aus der Antwort eines Cart-Writes fuellen. NACH schreibEnde() aufrufen.
  var GROSS_MAX = 262144; // darueber nicht parsen — change.js mit gerenderten Abschnitten kann gross werden
  function merkerAusAntwort(url, antwort) {
    if (!antwort || !antwort.ok || /\/cart\/add/.test(url)) return;
    var g = schreibGen, kopie;
    try { kopie = antwort.clone(); } catch (e) { return; }
    kopie.text().then(function (text) {
      if (schreibGen !== g) return;   // inzwischen ein weiterer Write: diese Antwort ist veraltet
      if (!text || text.length > GROSS_MAX) return;
      var d;
      try { d = JSON.parse(text); } catch (e) { return; }
      if (!d || typeof d.item_count !== 'number' || !Array.isArray(d.items)) return;
      if (d.sections !== undefined || d.sections_url !== undefined) {
        delete d.sections; delete d.sections_url;
        text = JSON.stringify(d);
      }
      leseMerker = { gen: g, at: Date.now(), status: 200, statusText: 'OK', ct: 'application/json; charset=utf-8', text: text };
    }, function () { /* Antwort nicht lesbar: Merker bleibt leer, der naechste Read geht ins Netz */ });
  }

  // Fremde Cart-Writes beobachten
  var fremdUnterwegs = 0;
  window.fetch = function (eingabe, init) {
    var url = '', eigen = false;
    try { url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || ''; eigen = !!(init && init.headers && init.headers[MARKER]); } catch (e) {}
    var methode = ((init && init.method) || (eingabe && eingabe.method) || 'GET').toUpperCase();
    if (methode === 'GET') return istCartRead(url) ? cartLesen(this, arguments) : fetchOriginal.apply(this, arguments);
    if (!/\/cart\/(add|change|update|clear)/.test(url)) return fetchOriginal.apply(this, arguments);
    // Cart-Write (eigen oder fremd): Generation vor und nach dem Write anheben
    schreibStart();
    if (eigen) {
      var pe = fetchOriginal.apply(this, arguments);
      pe.then(function (r) { schreibEnde(); merkerAusAntwort(url, r); }, schreibEnde);
      return pe;
    }
    fremdUnterwegs++;
    var abziehen = function () { fremdUnterwegs = Math.max(0, fremdUnterwegs - 1); };
    var p = fetchOriginal.apply(this, arguments);
    p.then(function (r) { abziehen(); schreibEnde(); merkerAusAntwort(url, r); },
           function () { abziehen(); schreibEnde(); });
    return p;
  };

  var offen = null, timer = null, laeuft = false;

  // v4: Nachlieferer. fn() gibt { key: wert } zurueck ODER nichts, und leert dabei seinen eigenen
  // Zwischenstand — sonst wuerde derselbe Wert spaeter ein zweites Mal geschrieben.
  var nachlieferer = [];
  window.mdzoCartNachliefern = function (fn) { if (typeof fn === 'function') nachlieferer.push(fn); };
  function planen() { if (timer) clearTimeout(timer); timer = setTimeout(senden, SAMMEL_MS); }

  window.mdzoCartWrite = function (body) {
    return new Promise(function (res) {
      if (!offen) offen = { attributes: {}, discount: undefined, hatDiscount: false, warter: [] };
      var attrs = body && body.attributes;
      if (attrs) for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) offen.attributes[k] = attrs[k];
      if (body && Object.prototype.hasOwnProperty.call(body, 'discount')) { offen.discount = body.discount; offen.hatDiscount = true; }
      offen.warter.push(res);
      if (!laeuft) planen();
    });
  };

  function senden() {
    timer = null;
    if (laeuft || !offen) return;
    laeuft = true;
    var paket = offen; offen = null;
    // v4: Ausstehendes einsammeln, bevor der Rumpf gebaut wird. Ein ausdruecklicher Aufruf hat Vorrang.
    for (var ni = 0; ni < nachlieferer.length; ni++) {
      try {
        var zusatz = nachlieferer[ni]();
        if (zusatz) for (var zk in zusatz) {
          if (Object.prototype.hasOwnProperty.call(zusatz, zk) && !Object.prototype.hasOwnProperty.call(paket.attributes, zk)) paket.attributes[zk] = zusatz[zk];
        }
      } catch (e) { /* ein kaputter Nachlieferer darf den Write nicht verhindern */ }
    }
    var body = {};
    if (Object.keys(paket.attributes).length) body.attributes = paket.attributes;
    if (paket.hatDiscount) body.discount = paket.discount;
    var start = Date.now();
    var warten = function () {
      if (fremdUnterwegs > 0 && Date.now() - start < MAX_WARTEN_MS) return new Promise(function (r) { setTimeout(r, TAKT_MS); }).then(warten);
      return Promise.resolve();
    };
    var post = function () {
      var headers = { 'Content-Type': 'application/json' }; headers[MARKER] = '1';
      return window.fetch(UPDATE, { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify(body) });
    };
    var ergebnis = function (r) { return r && r.ok ? r.json() : null; };
    warten().then(post).then(function (r) {
      if (r && r.ok) return ergebnis(r);
      return new Promise(function (res) { setTimeout(res, WIEDERHOLUNG_MS); }).then(post).then(ergebnis);
    }).catch(function () { return null; }).then(function (cart) {
      laeuft = false;
      for (var i = 0; i < paket.warter.length; i++) { try { paket.warter[i](cart || null); } catch (e) {} }
      if (offen) planen();
    });
  }
})();
